import React from "react";
import { motion } from "framer-motion";

const easeOutQuint = [0.22, 1, 0.36, 1];

export default function Reveal({
  children,
  delay = 0,
  duration = 0.7,
  y = 24,
  once = true,
  amount = 0.25,
  as: Component = motion.div,
  style,
  ...rest
}) {
  return (
    <Component
      initial="hidden"
      whileInView="show"
      viewport={{ once, amount }}
      variants={{
        hidden: { opacity: 0, y, filter: "blur(10px)" },
        show: {
          opacity: 1,
          y: 0,
          filter: "blur(0px)",
          transition: { duration, delay, ease: easeOutQuint },
        },
      }}
      style={style}
      {...rest}
    >
      {children}
    </Component>
  );
}
